<!-- Editable -->
@if (project_name === "syrsa") {
    @if (editable) {
        <div fxLayout="row" id="item-stars">
            @for (star of currentStars; track star; let i = $index) {
                <div [ngClass]="{ me: view === 'me', pointer: editable === true }" [id]="i" (click)="setStar(i)">
                    @if (star === "X" && i == 0) {
                        <mat-icon class="star1">star</mat-icon>
                    }
                    @if (star === "X" && i == 1) {
                        <mat-icon class="star2">star</mat-icon>
                    }
                    @if (star === "X" && i == 2) {
                        <mat-icon class="star3">star</mat-icon>
                    }
                    @if (star === "X" && i == 3) {
                        <mat-icon class="star4">star</mat-icon>
                    }
                    @if (star === "X" && i == 4) {
                        <mat-icon class="star5">star</mat-icon>
                    }
                    @if (star === "-") {
                        <mat-icon class="gray">star</mat-icon>
                    }
                </div>
            }
        </div>
    }
    @if (editable) {
        <div fxLayout="row" fxLayoutAlign="center center">
            @if (countVal() == 0) {
                <label></label>
            }
            @if (countVal() == 1) {
                <span style="color: rgb(255, 0, 0)">Bajo</span>
            }
            @if (countVal() == 2) {
                <label style="color: rgb(255, 154, 2)">Medio-Bajo</label>
            }
            @if (countVal() == 3) {
                <label style="color: rgb(255, 192, 2)">Medio</label>
            }
            @if (countVal() == 4) {
                <label style="color: rgb(146, 208, 80)">Alto</label>
            }
            @if (countVal() == 5) {
                <label style="color: rgb(0, 176, 80)">Muy Alto</label>
            }
        </div>
    }
    @if (!editable) {
        <div fxLayout="row" id="item-stars">
            @for (star of currentStars; track star; let i = $index) {
                <div [ngClass]="{ me: view === 'me', pointer: editable === true }" [id]="i">
                    @if (star === "X" && i == 0) {
                        <mat-icon class="star1">star</mat-icon>
                    }
                    @if (star === "X" && i == 1) {
                        <mat-icon class="star2">star</mat-icon>
                    }
                    @if (star === "X" && i == 2) {
                        <mat-icon class="star3">star</mat-icon>
                    }
                    @if (star === "X" && i == 3) {
                        <mat-icon class="star4">star</mat-icon>
                    }
                    @if (star === "X" && i == 4) {
                        <mat-icon class="star5">star</mat-icon>
                    }
                    @if (star === "-") {
                        <mat-icon class="gray">star</mat-icon>
                    }
                </div>
            }
        </div>
    }
    @if (!editable) {
        <div fxLayout="row" fxLayoutAlign="center center">
            @if (countVal() == 0) {
                <label></label>
            }
            @if (countVal() == 1) {
                <span style="color: rgb(255, 0, 0)">Bajo</span>
            }
            @if (countVal() == 2) {
                <label style="color: rgb(255, 154, 2)">Medio-Bajo</label>
            }
            @if (countVal() == 3) {
                <label style="color: rgb(255, 192, 2)">Medio</label>
            }
            @if (countVal() == 4) {
                <label style="color: rgb(146, 208, 80)">Alto</label>
            }
            @if (countVal() == 5) {
                <label style="color: rgb(0, 176, 80)">Muy Alto</label>
            }
        </div>
    }
}
@if (project_name !== "syrsa") {
    @if (editable) {
        <div fxLayout="row" id="item-stars">
            @for (star of currentStars; track star; let i = $index) {
                <div [ngClass]="{ me: view === 'me', pointer: editable === true }" [id]="i" (click)="setStar(i)">
                    @if (canNA) {
                        @if (star === "X" && i == 0) {
                            <mat-icon class="star1Blue">clear</mat-icon>
                        }
                    }
                    @if (star === "X" && i == 1) {
                        <mat-icon class="star2Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 2) {
                        <mat-icon class="star3Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 3) {
                        <mat-icon class="star4Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 4) {
                        <mat-icon class="star5Blue">star</mat-icon>
                    }
                    @if (canNA) {
                        @if (star === "-" && i == 0) {
                            <mat-icon class="gray">clear</mat-icon>
                        }
                    }
                    @if (star === "-" && i != 0) {
                        <mat-icon class="gray">star</mat-icon>
                    }
                </div>
            }
        </div>
    }
    @if (!editable) {
        <div fxLayout="row" id="item-stars">
            @for (star of currentStars; track star; let i = $index) {
                <div [ngClass]="{ me: view === 'me', pointer: editable === true }" [id]="i">
                    @if (canNA) {
                        @if (star === "X" && i == 0) {
                            <mat-icon class="star1Blue">clear</mat-icon>
                        }
                    }
                    @if (star === "X" && i == 1) {
                        <mat-icon class="star2Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 2) {
                        <mat-icon class="star3Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 3) {
                        <mat-icon class="star4Blue">star</mat-icon>
                    }
                    @if (star === "X" && i == 4) {
                        <mat-icon class="star5Blue">star</mat-icon>
                    }
                    @if (canNA) {
                        @if (star === "-" && i == 0) {
                            <mat-icon class="gray">clear</mat-icon>
                        }
                    }
                    @if (star === "-" && i != 0) {
                        <mat-icon class="gray">star</mat-icon>
                    }
                </div>
            }
        </div>
    }
}
